import React from 'react';
import { Link } from 'react-router-dom';

const renderMenuItem = (item,i,props, root = false) => {
  var itemState = props.elementStates[item.key];
  
  if(typeof itemState === "undefined" 
     || !itemState.enabled) {
    return null;
  }
  
  if(item.childs) {
    return (
      <li key={i} className={
        (itemState.open ? "menu_item_open" : "menu_item_closed") + 
        (itemState.active ? " menu_item_active" : " menu_item_not_active") +
        (" menu_key_" + item.key)
      }>
        <div data-key={item.key} data-parent="true" onClick={props.handleClickMenuItem}  id={item.key}>
          {item.icon ? (<i className={"fas "+item.icon}/>) : null}
          {item.label}
          {itemState.open ? (<i className={"arrow_expand fas fa-angle-up"}/>) : (<i className={"arrow_expand fas fa-angle-down"}/>)}
        </div>
        <ul>{item.childs.map((childItem, j) => { return renderMenuItem(childItem,j,props); })}</ul>
      </li>
    );
  }
  else {
    return (
      <li key={i} className={(itemState.active ? "menu_item_active" : "menu_item_not_active") + " menu_key_" + item.key} >
        <div>          
          <Link data-key={item.key} to={item.route} onClick={props.handleClickMenuItem} id={item.key}>
            {item.icon ? (<i className={"fas "+item.icon}/>) : null}
            {item.label}
          </Link>
        </div>
      </li>);    
  }
};

const MainMenu = props => {
  const {
    elements,
    elementStates,
    handleClickMenuItem,
    handleClickHideMenu,
    hideMenuStatus,
    showMenuOnHoverStatus,
    show
  } = props;
  return (
    <React.Fragment>
      <div className={"dashboard_main_menu" +  (hideMenuStatus ? " dashboard_main_menu_hidden" : "") + (showMenuOnHoverStatus ? " dashboard_main_menu_allow_hover" : "")}>
        <div className="dashboard_main_menu_inner">
          {show && (
            <div className="main_menu_container">
              <ul>{elements.map((item, i) => { return renderMenuItem(item,i,props, true); })}</ul>
            </div>          
          )}
        </div>
      </div>
      <div className={"main_menu_hide_icon" + (hideMenuStatus ? " main_menu_hide_icon_hidden" : "")} onClick={handleClickHideMenu}>
        <i className="fas fa-chevron-down"></i>
      </div>
    </React.Fragment>
  );
};

export default MainMenu;



// WEBPACK FOOTER //
// ./source/client/components/dashboard/mainMenu.jsx